// Stable per-browser device id, the web analogue of Android's DeviceIdProvider
// (ANDROID_ID / UUID). Used to stamp `trackingDeviceId` on a task when tracking
// starts, so other devices can tell "this timer was started somewhere else".
// Persisted in localStorage so it survives reloads (but is per-browser).
const DEVICE_ID_KEY = "web_device_id";

export const getDeviceId = () => {
  let id = null;
  try {
    id = localStorage.getItem(DEVICE_ID_KEY);
  } catch (e) {
    // localStorage unavailable (private mode etc.) — fall through to ephemeral.
  }
  if (!id) {
    id =
      (typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID()) ||
      `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    try {
      localStorage.setItem(DEVICE_ID_KEY, id);
    } catch (e) {
      /* ignore */
    }
  }
  return id;
};
